import { Injectable, computed, signal } from '@angular/core';
import { AuthUser } from './auth.models';

export type AuthenticationStatus = 'checking' | 'authenticated' | 'unauthenticated';

@Injectable({ providedIn: 'root' })
export class AuthSessionStore {
  private readonly userState = signal<AuthUser | null>(null);
  private readonly statusState = signal<AuthenticationStatus>('checking');
  private readonly revisionState = signal(0);

  readonly user = this.userState.asReadonly();
  readonly status = this.statusState.asReadonly();
  /**
   * Changes for every authentication identity transition, including a refresh
   * of the same user. Consumers can use it to invalidate user-scoped state.
   */
  readonly revision = this.revisionState.asReadonly();
  readonly authenticated = computed(() => this.statusState() === 'authenticated');

  setUser(user: AuthUser): void {
    this.userState.set(user);
    this.statusState.set('authenticated');
    this.revisionState.update((revision) => revision + 1);
  }

  clear(): void {
    this.userState.set(null);
    this.statusState.set('unauthenticated');
    this.revisionState.update((revision) => revision + 1);
  }
}
